import React from "react";
import { Link } from "react-router-dom";
import Logo from "../Logo";

export default function Header() {
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-[#E6E3DB]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <Logo size={32} />
          <span className="font-serif text-xl">Finhabits</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-[#787671]">
          <a href="/#loop" className="hover:text-[#2C302E]">The Loop</a>
          <a href="/#calendar" className="hover:text-[#2C302E]">Calendar</a>
          <a href="/#features" className="hover:text-[#2C302E]">Features</a>
          <Link to="/strategy" className="hover:text-[#2C302E]" data-testid="header-strategy-link">Strategy</Link>
          <Link
            to="/quiz"
            className="font-medium hover:opacity-80 transition-opacity"
            style={{ color: "#A9712A" }}
            data-testid="header-quiz-link"
          >
            MoneyMind Quiz
          </Link>
          <Link to="/couples" className="hover:text-[#2C302E]" data-testid="header-couples-link">Couples</Link>
          <a href="/#pricing" className="hover:text-[#2C302E]">Pricing</a>
          <a
            href={`${process.env.REACT_APP_BLOG_URL || "https://finhabits.blogspot.com/"}?utm_source=finhabits-app&utm_medium=header-nav&utm_campaign=blog_link`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#2C302E]"
            data-testid="header-blog-link"
          >
            Blog
          </a>
          <Link to="/about" className="hover:text-[#2C302E]" data-testid="header-about-link">About</Link>
          <Link to="/contact" className="hover:text-[#2C302E]" data-testid="header-contact-link">Contact</Link>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/login" className="text-sm hover:underline" data-testid="header-login-link">
            Sign in
          </Link>
          <Link
            to="/register"
            className="px-4 py-2 rounded-sm bg-[#2C302E] text-white text-sm hover:bg-[#1b1e1c] transition-colors"
            data-testid="header-signup-link"
          >
            Start free
          </Link>
        </div>
      </div>
    </header>
  );
}
